import { gql } from '@apollo/client';

export const CURRICULUM_QUERY = gql`
    query curriculum($curriculumID: UUID!) {
        curriculum(curriculumID: $curriculumID) {
            node {
                id
                locales {
                    locale
                    name
                    description
                }
                thumbnailImage {
                    id
                    name
                    url
                    __typename
                }
                heroImage {
                    id
                    name
                    url
                    __typename
                }
                courses(useSegmentationFilter: false) {
                    edges {
                        node {
                            id
                            locales {
                                locale
                                name
                                description
                            }
                        }
                    }
                }
                prerequisiteSet {
                    id
                    objectId
                    operator
                    type
                    prerequisites {
                        objectId
                        weight
                    }
                }
                prerequisiteStatus { 
                    isPrerequisiteOf
                    hasPrerequisites
                }
                isPublic
                tags
                tagIds
                isFeatured
                weight
                isSequential
                categoryIds
                resourceIds
                learningProfileIds
                segmentIds
                localeIds
                companyRelationshipIds
                employeeLocaleIds
                brandIds
                productIds
                metadata
                createdAt
                updatedAt
            }
        }
    }
`;
